import React from "react";
import { Icon } from "components/Icon/Icon";
import { Progress } from "reactstrap";
import { pollingRequestStatuses } from "providers/SharedWorkerProvider/SharedWorkerContext";
import { useTranslate } from "hooks";

export const ProgressBar = ({ requestInProgress }) => {
  const translate = useTranslate();
  const { status } = requestInProgress;
  return (
    <div
      className="position-absolute w-auto text-blue-300 d-flex flex-column"
      style={{ right: "2rem", top: "0" }}
    >
      {status === pollingRequestStatuses.inProgress && (
        <>
          <div>
            <Icon
              prefix="trox"
              iconName="arrow-down-bracket-light"
              className="me-2"
            />
            {translate("GENERATION_IN_PROGRESS")}
          </div>
          <Progress
            value={100}
            animated={true}
            className="bg-gray-300 rounded-3 mt-1 overflow-hidden"
            color="info"
            style={{ height: "0.375rem" }}
          />
        </>
      )}
      {status === pollingRequestStatuses.error && (
        <div className="d-flex align-items-center text-danger">
          <Icon
            className="text-danger icon-20 mx-3"
            iconName="circle-info-regular"
            prefix="trox"
          />
          {translate("GENERATION_FAILED")}
        </div>
      )}
    </div>
  );
};
